/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_TemplatesInputs */

const en_mk_cmp_templates = /** @type {(inputs: Mk_Cmp_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template gallery`)
};

const id_mk_cmp_templates = /** @type {(inputs: Mk_Cmp_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeri template`)
};

/**
* | output |
* | --- |
* | "Template gallery" |
*
* @param {Mk_Cmp_TemplatesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_templates = /** @type {((inputs?: Mk_Cmp_TemplatesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_TemplatesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_templates(inputs)
	return en_mk_cmp_templates(inputs)
});